import App from "containers/App";
import PageIdentification from "containers/PageIdentification";
import PageIdentificationCgn from "containers/PageIdentificationCgn";
import PageReset from "containers/PageReset";
import PageResetCgn from "containers/PageResetCgn";
import PageAppointments from "containers/PageAppointments";
import PageActivations from "containers/PageActivations";
import PageNotFound from "containers/PageNotFound";
import PageCgn from "../containers/PageCgn";

import consts from "consts/consts";

const routes = [
  {
    component: App,
    routes: [
      {
        path: consts.routes.home.url,
        exact: true,
        component: PageIdentification,
        title: consts.routes.home.title,
      },
      {
        path: consts.routes.reset.url,
        exact: true,
        component: PageReset,
        title: consts.routes.reset.title,
      },
      {
        path: consts.routes.reset_cgn.url,
        exact: true,
        component: PageResetCgn,
        title: consts.routes.reset_cgn.title,
      },
      {
        path: consts.routes.appointments.url,
        exact: true,
        component: PageAppointments,
        title: consts.routes.appointments.title,
      },
      {
        path: consts.routes.cgn_login.url,
        exact: true,
        component: PageIdentificationCgn,
        title: consts.routes.cgn_login.title,
      },
      {
        path: consts.routes.cgn.url,
        exact: true,
        component: PageCgn,
        title: consts.routes.cgn.title,
      },
      {
        path: consts.routes.activations.url,
        exact: true,
        component: PageActivations,
        title: consts.routes.activations.title,
      },
      {
        path: "*",
        component: PageNotFound,
        title: "Erreur 404",
      },
    ],
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/consts/routes.js